<template>
  <card>
    <div class="event-card" :class="{'event-card--color': currentEvent.color}" :style="customStyle">
      <div class="event-card__top">
        <div class="event-card__date">
          <span class="event-card__date-day">{{ currentEvent.day }}</span>
          <span class="event-card__date-month">{{ currentEvent.month }}</span>
        </div>
        <div class="event-card__price event-card__spacing">
          <div class="event-card__label">
            <icon class="icon--price" symbol="icon-price" />
            <span class="event-card__label-text">Preis</span>
          </div>
          <p class="event-card__price-text">{{ currentEvent.price }}</p>
        </div>
      </div>
      <h3 class="event-card__title event-card__spacing">{{ currentEvent.title }}</h3>
      <div class="event-card__time event-card__spacing">
        <div class="event-card__label">
          <icon symbol="icon-clock" />
          <span class="event-card__label-text">Wann?</span>
        </div>
        <p>{{ currentEvent.startDate }}</p>
        <p>von {{ currentEvent.startTime }} bis {{ currentEvent.endTime }}</p>
      </div>

      <div class="event-card__location event-card__spacing">
        <div class="event-card__label">
          <icon symbol="icon-location" />
          <span class="event-card__label-text">Wo?</span>
        </div>
        <p><a :href="currentEvent.mapsLink" target="_blank">{{ currentEvent.address }}</a></p>
      </div>
      <div class="event-card__available-places event-card__spacing" v-if="isLoggedIn">
        <div class="event-card__label">
          <icon symbol="icon-person" />
          <span class="event-card__label-text">Verfügbare Plätze: {{ currentEvent.availablePlaces }}</span>
        </div>

      </div>
      <div class="event-card__c2a" v-if="currentEvent.availablePlaces > 0">
        <button class="button button--outline" @click="setEventToStoreHandler">{{ $t('book-now') }}</button>
      </div>
      <div class="event-card__c2a" v-else>
        <button class="button button--outline" disabled>{{ $t('booking.noBooking') }}</button>
      </div>
    </div>
  </card>
</template>

<script>
  import { formatDate, formatTime, formatShortDate } from "../helpers/filters";
  import { currentEventFormatter } from "../helpers/event-formatter";
  import { mapActions, mapGetters } from 'vuex'
  import AppBooking from "./AppBooking";
  export default {
    name: "AppEventCard",
    props: {
      event: {
        type: Object,
        required: true
      }
    },
    components: {
      AppBooking
    },
    filters: {
      formatDate,
      formatTime,
      formatShortDate
    },
    computed: {
      ...mapGetters('auth', ['isLoggedIn']),
      customStyle() {
        return {
          '--event-color': this.currentEvent.color
        }
      },
      currentEvent() {
        return currentEventFormatter(this.event, this.$options.filters)
      }
    },
    methods: {
      ...mapActions('bookEvents', ['setCurrentEvent']),
      setEventToStoreHandler() {
        this.setCurrentEvent(this.currentEvent);
      }
    }
  }
</script>
